import { Rpc } from '../rpc';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcElectronOperationResult, RpcElectronResponseKey } from './rpc-electron-model';

export class RpcElectronResponseClient {
    /**
     * The Rpc Electron response command.
     *
     * @param rpc the rpc service.
     * @param data the azure operation result object.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<void> the promise object.
     */
    public static electronResponse(rpc: Rpc, data: RpcElectronOperationResult): Promise<void>;
    public static electronResponse(rpc: Rpc, data: RpcElectronOperationResult, outbound?: RpcOutbound): Promise<void>;
    public static electronResponse(rpc: Rpc, data: RpcElectronOperationResult, outbound?: RpcOutbound): Promise<void> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcElectronResponseKey.command,
                RpcElectronResponseKey.version,
                data
            );
        } else {
            return RpcOutboundClient.call(rpc, RpcElectronResponseKey.command, RpcElectronResponseKey.version, data);
        }
    }
}
